export enum RecurringTaskAction {
  None = 0,
  Cancel = 1,
  Pause = 2,
  CancelAndPause = Cancel | Pause,
  Resume = None,
  Execute = 8,
  ResumeAndExecute = Resume | Execute,
}
